import BaseSensorExtension from '../base-sensor';
import formatMessage from 'format-message';

class DcMotorExtension extends BaseSensorExtension {
    constructor (runtime) {
        super(runtime);
    }

    getSensorInfo () {
        return {
            id: 'dcMotor',
            name: 'DC Motor',
            color1: '#D81B60',
            color2: '#C2185B',
            color3: '#AD1457',

            blocks: [
                {
                    opcode: 'dcMotor_setSpeed',
                    blockType: 'command',
                    text: formatMessage({
                        id: 'dcMotor.blocks.setSpeed',
                        default: 'set motor on pin [PIN] speed [SPEED]'
                    }),
                    arguments: {
                        PIN: {
                            type: 'number',
                            defaultValue: '9',
                            menu: 'digitalPinMenu'
                        },
                        SPEED: {
                            type: 'number',
                            defaultValue: '255'
                        }
                    }
                },
                {
                    opcode: 'dcMotor_stop',
                    blockType: 'command',
                    text: formatMessage({
                        id: 'dcMotor.blocks.stop',
                        default: 'stop motor on pin [PIN]'
                    }),
                    arguments: {
                        PIN: {
                            type: 'number',
                            defaultValue: '9',
                            menu: 'digitalPinMenu'
                        }
                    }
                }
            ],

            menus: {},

            codeTemplates: [
                {
                    opcode: 'dcMotor_setSpeed',
                    type: 'command',
                    arduino: {
                        code: 'analogWrite({{PIN}}, {{SPEED}});',
                        setup: ['pinMode({{PIN}}, OUTPUT);'],
                        includes: []
                    },
                    python: {
                        code: 'pwm_{{PIN}}.duty_u16(int(({{SPEED}} / 255.0) * 65535))',
                        setup: [
                            'pwm_{{PIN}} = PWM(Pin({{PIN}}))',
                            'pwm_{{PIN}}.freq(1000)'
                        ],
                        imports: ['from machine import Pin, PWM']
                    }
                },
                {
                    opcode: 'dcMotor_stop',
                    type: 'command',
                    arduino: {
                        code: 'analogWrite({{PIN}}, 0);',
                        setup: ['pinMode({{PIN}}, OUTPUT);'],
                        includes: []
                    },
                    python: {
                        code: 'pwm_{{PIN}}.duty_u16(0)',
                        setup: [
                            'pwm_{{PIN}} = PWM(Pin({{PIN}}))',
                            'pwm_{{PIN}}.freq(1000)'
                        ],
                        imports: ['from machine import Pin, PWM']
                    }
                }
            ]
        };
    }

    dcMotor_setSpeed (args) {
        return Promise.resolve();
    }

    dcMotor_stop (args) {
        return Promise.resolve();
    }
}

export default DcMotorExtension;
